<!-- Mobile: Foxera Drawer Full -->
@if (responsiveService.isMobileView()) {
  <foxera-drawer-full
    [(visible)]="visible"
    [title]="''"
    [showFooter]="false"
    [useCustomHeader]="true"
    (onClose)="onClose()"
    (onScroll)="onContentScroll($event)">
    
    <!-- Custom Header -->
    <div customHeader class="px-4 pt-4 pb-3">
      <!-- Title and Close Button -->
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-2">
          <h3 class="text-lg font-semibold text-grey-950">{{ headerTitle() }}</h3>
          <span class="px-2 py-0.5 bg-primary-50 border border-primary-200 rounded-full text-[0.65rem] font-semibold text-primary-800">
            {{ totalCount() }}
          </span>
        </div>
        <button
          (click)="onClose()"
          class="flex items-center justify-center w-9 h-9 rounded-full bg-white/60 hover:bg-white border border-white transition-all duration-150 [-webkit-tap-highlight-color:transparent]">
          <span class="pi pi-times text-grey-600 text-base"></span>
        </button>
      </div>
      
      <!-- Branch Filter -->
      <div class="mb-3">
        <foxera-branch-selector
          [formControl]="branchFilterControl"
          [readonly]="isBranchLocked()"
          (branchSelected)="onBranchSelected($event)"
        />
      </div>

      <!-- Search & Filters Row -->
      <div class="flex items-center gap-2">
        <!-- Search Input -->
        <div class="flex-1 flex items-center gap-2 px-3 py-2 rounded-xl border border-white bg-white/60 focus-within:border-primary-500 focus:border focus:border-2">
          <span class="icon-search text-sm text-grey-400"></span>
          <input
            type="text"
            [formControl]="searchControl"
            placeholder="Search..."
            class="flex-1 bg-transparent border-0 outline-none text-grey-950 placeholder:text-grey-400 text-sm"
          />
        </div>

        <!-- Filters Button -->
        <button
          type="button"
          class="relative flex items-center justify-center w-10 h-10 rounded-xl border border-white bg-white/60 transition-all duration-200"
          (click)="onOpenFilters()">
          <span class="pi pi-filter text-base text-grey-800"></span>
          @if (activeFilterCount() > 0) {
            <span class="absolute -top-1.5 -right-1.5 min-w-[1.125rem] h-[1.125rem] px-1 bg-primary-600 text-white rounded-full text-[0.55rem] font-bold flex items-center justify-center shadow-md border border-white">
              {{ activeFilterCount() }}
            </span>
          }
        </button>
      </div>
    </div>
    
    <!-- Content -->
    <ng-container *ngTemplateOutlet="exerciseContent"></ng-container>
  </foxera-drawer-full>
}

<!-- Desktop: Original Full Screen Modal -->
@if (!responsiveService.isMobileView()) {
  <div class="fixed inset-0 z-[1000] bg-white w-screen h-screen overflow-hidden animate-fade-in">
    <div class="w-full h-full p-4 animate-scale-in" style="background: var(--Gradiant-background);">
      <div #gridContainer class="w-full h-full bg-white rounded-[2rem] flex flex-col relative shadow-lg select-none">
        <ng-container *ngTemplateOutlet="desktopHeader"></ng-container>
        <ng-container *ngTemplateOutlet="exerciseContent"></ng-container>
      </div>
    </div>
  </div>
}

<!-- Desktop Header Template -->
<ng-template #desktopHeader>
  <!-- Header -->
  <div class="flex-shrink-0 flex items-center justify-between px-8 py-6 border-b border-grey-100">
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200 text-grey-700 flex items-center justify-center transition-colors cursor-pointer"
        (click)="onClose()"
        title="Close">
        <i class="pi pi-arrow-left text-lg"></i>
      </button>
      <h1 class="text-2xl font-bold text-grey-900">{{ headerTitle() }}</h1>
    </div>
  </div>

  <!-- Search & Filters Bar -->
  <div class="flex-shrink-0 px-8 py-4 border-b border-grey-100">
    <div class="flex items-center gap-3">
      <!-- Search Input -->
      <div class="flex items-center gap-2 px-4 py-2 rounded-[1.625rem] border border-white 
      focus-within:border-primary-500  bg-white/50 shadow-[0_0.125rem_0.65rem_0_rgba(0,0,0,0.08)] text-[0.8rem] font-normal w-[34.375rem]">
        <span class="icon-search text-[0.875rem] text-grey-400"></span>
        <input
          type="text"
          [formControl]="searchControl"
          placeholder="Search exercises by name..."
          class="flex-1 bg-transparent border-0 outline-none text-grey-950 placeholder:text-grey-400"
        />
      </div>

      <!-- Branch Filter -->
      <foxera-branch-selector
        [formControl]="branchFilterControl"
        [readonly]="isBranchLocked()"
        (branchSelected)="onBranchSelected($event)"
      />

      <!-- Filters Button -->
      <button
        type="button"
        class="flex items-center gap-2 px-4 py-2 rounded-[1.625rem] border border-white bg-white/50 shadow-[0_0.125rem_0.65rem_0_rgba(0,0,0,0.08)] text-[0.8rem] text-grey-950 font-normal cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 active:scale-95"
        (click)="onOpenFilters()">
        <span class="icon-filter text-[0.875rem] text-grey-800"></span>
        <span>Filters</span>
        @if (activeFilterCount() > 0) {
          <span class="ml-1 px-2 py-0.5 bg-primary-500 text-white rounded-full text-[0.65rem] font-semibold">
            {{ activeFilterCount() }}
          </span>
        }
      </button>

      <!-- Results count -->
      <div class="flex-1 text-right text-sm text-grey-600">
        {{ totalCount() }} exercises
      </div>
    </div>
  </div>
</ng-template>

<!-- Shared Exercise Content Template -->
<ng-template #exerciseContent>
  <!-- Exercise Grid -->
  <div class="flex-1 relative"
       [class.overflow-y-auto]="!responsiveService.isMobileView()"
       (scroll)="onContentScroll($event)">
    
    <!-- Active Filters Chip (Floating) - Sticky -->
    @if (activeFilterCount() > 0) {
      <div class="sticky top-0 left-0 right-0 z-30 w-full flex justify-center py-2 pb-3 animate-fade-in pointer-events-none">
        <div class="flex items-center gap-1.5 md:gap-2 px-2.5 md:px-3 py-1.5 md:py-2 rounded-full border border-primary-200/40 bg-primary-50/70 backdrop-blur-md shadow-md w-fit max-w-[90%] md:max-w-[80%] pointer-events-auto">
          <!-- Filter label -->
          <span class="text-[0.6rem] md:text-[0.7rem] font-medium text-primary-800 flex-shrink-0">Filters:</span>
          
          <!-- Individual filter tags -->
          <div class="flex items-center gap-1 md:gap-1.5 flex-wrap">
            @for (tag of activeFilterTags().slice(0, responsiveService.isMobileView() ? 3 : 4); track tag) {
              <span class="inline-flex items-center px-1.5 md:px-2 py-0.5 bg-primary-100/80 border border-primary-300/50 rounded-full text-[0.6rem] md:text-[0.7rem] font-semibold text-primary-900">
                {{ tag }}
              </span>
            }
            @if (activeFilterTags().length > (responsiveService.isMobileView() ? 3 : 4)) {
              <span class="inline-flex items-center px-1.5 md:px-2 py-0.5 bg-primary-100/80 border border-primary-300/50 rounded-full text-[0.6rem] md:text-[0.7rem] font-semibold text-primary-900">
                +{{ activeFilterTags().length - (responsiveService.isMobileView() ? 3 : 4) }}
              </span>
            }
          </div>
          
          <!-- Clear all button -->
          <button
            type="button"
            class="flex items-center justify-center w-6 h-6 rounded-full bg-primary-600 hover:bg-primary-800 transition-colors cursor-pointer flex-shrink-0 ml-0.5 md:ml-1 [-webkit-tap-highlight-color:transparent]"
            (click)="onClearAllFilters()"
            title="Clear all filters">
            <span class="pi pi-times text-white text-[0.65rem]"></span>
          </button>
        </div>
      </div>
    }
    
    <!-- Scrollable Content Area -->
    <div class="px-3 md:px-8 py-3 md:py-6">
    
    <!-- Loading State -->
    @if (isLoading()) {
      <div class="flex items-center justify-center h-full">
        <app-global-loading 
          [loadingText]="'Loading exercises...'"
          [showOverlay]="false"
          [isLoading]="isLoading()">
        </app-global-loading>
      </div>
    }

    <!-- Exercise Cards -->
    @if (!isLoading() && exercises().length > 0) {
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4" [class.pb-32]="showSelectionUI() && selectedExercisesForApply().length > 0" [class.pb-20]="!(showSelectionUI() && selectedExercisesForApply().length > 0)">
        @for (exercise of exercises(); track exercise.id) {
          <div 
            class="group cursor-pointer bg-white/40 md:bg-gradient-to-br md:from-grey-50 md:to-white rounded-xl border-2 overflow-hidden transition-all duration-300 hover:shadow-lg relative"
            [ngClass]="isExerciseSelected(exercise) ? 'border-primary-500 md:ring-1 md:ring-primary-200' : 'border-2 border-gray-200 md:border-1 md:border-grey-100 hover:border-primary-300'"
            (click)="onViewExercise(exercise, $event)">
            
            <!-- Selection Checkbox - only in add/switch mode -->
            @if (showSelectionUI()) {
              <div 
                class="absolute top-2 md:top-3 left-2 md:left-3 z-10"
                (click)="onToggleExerciseSelection(exercise); $event.stopPropagation()">
                <div 
                  class="w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all duration-200 cursor-pointer"
                  [ngClass]="isExerciseSelected(exercise) 
                    ? 'bg-primary-500 border-primary-500' 
                    : 'bg-white border-gray-300 hover:border-primary-400'">
                  @if (isExerciseSelected(exercise)) {
                    <i class="pi pi-check text-white text-xs"></i>
                  }
                </div>
              </div>
            }
            
            <!-- Image -->
            <div class="relative w-full h-32 md:h-40 overflow-hidden bg-grey-200">
              @if (exercise.imagePath) {
                <img 
                  [src]="exercise.imagePath" 
                  [alt]="exercise.name" 
                  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div class="absolute inset-0 bg-gradient-to-t from-primary-100/40 to-transparent"></div>
              } @else {
                <div class="w-full h-full flex items-center justify-center">
                  <i class="pi pi-image text-grey-400 text-2xl md:text-3xl"></i>
                </div>
              }
              
              <!-- Average Duration Badge (Top Right) -->
              @if (exercise.avgDuration && exercise.avgDuration > 0) {
                <div class="absolute bottom-2 right-2 flex items-center gap-1 px-2 md:px-2.5 py-1 md:py-1.5 rounded-full bg-gradient-to-br from-white/90 to-white/70 backdrop-blur-md border border-white/50 shadow-md">
                  <span class="text-[0.6rem] md:text-[0.65rem] font-semibold text-grey-800">{{ exercise.avgDuration }} min</span>
                </div>
              }
            </div>

            <!-- Content -->
            <div class="p-3 md:p-4 space-y-2 md:space-y-3">
              <!-- Title & Level -->
              <div class="flex items-start justify-between gap-2">
                <h4 class="text-xs md:text-sm font-bold text-grey-900 line-clamp-1 leading-tight flex-1">
                  {{ exercise.name }}
                </h4>
                <span 
                  class="flex-shrink-0 px-1.5 md:px-2 py-0.5 rounded text-[0.55rem] md:text-[0.6rem] font-medium uppercase tracking-wider"
                  [ngClass]="getLevelClass(exercise.level)">
                  {{ exercise.level }}
                </span>
              </div>
              
              <!-- Muscles -->
              <div class="flex flex-wrap gap-1 md:gap-1.5">
                @for (muscle of exercise.muscles.slice(0, 2); track muscle) {
                  <span class="inline-flex items-center px-2 md:px-2.5 py-0.5 md:py-1 border border-grey-200 text-grey-700 rounded-full text-[0.6rem] md:text-[0.65rem] font-semibold">
                    {{ muscle }}
                  </span>
                }
                @if (exercise.muscles.length > 2) {
                  <span class="inline-flex items-center px-2 md:px-2.5 py-0.5 md:py-1 border border-grey-200 text-grey-700 rounded-full text-[0.6rem] md:text-[0.65rem] font-semibold">
                    +{{ exercise.muscles.length - 2 }}
                  </span>
                }
              </div>

            </div>
          </div>
        }

        <!-- Skeleton Loading Cards (shown while loading more) -->
        @if (isLoadingMore() && skeletonCount() > 0) {
          @for (skeleton of skeletonArray(); track skeleton) {
            <div class="bg-white rounded-xl border-2 border-gray-100 overflow-hidden animate-pulse">
              <!-- Skeleton Image -->
              <div class="w-full h-32 md:h-40 bg-gray-200"></div>
              
              <!-- Skeleton Content -->
              <div class="p-3 md:p-4 space-y-2 md:space-y-3">
                <!-- Skeleton Title & Level -->
                <div class="flex items-start justify-between gap-2">
                  <div class="flex-1 h-4 bg-gray-200 rounded"></div>
                  <div class="w-16 h-4 bg-gray-200 rounded"></div>
                </div>
                
                <!-- Skeleton Muscles -->
                <div class="flex flex-wrap gap-1 md:gap-1.5">
                  <div class="w-20 h-6 bg-gray-200 rounded-full"></div>
                  <div class="w-24 h-6 bg-gray-200 rounded-full"></div>
                  <div class="w-16 h-6 bg-gray-200 rounded-full"></div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    }

    <!-- Empty State -->
    @if (!isLoading() && exercises().length === 0) {
      <div class="flex flex-col items-center justify-center h-full gap-4">
        <div class="w-16 md:w-20 h-16 md:h-20 rounded-full bg-grey-100 flex items-center justify-center">
          <i class="pi pi-search text-grey-400 text-2xl md:text-3xl"></i>
        </div>
        <h2 class="text-lg md:text-xl font-semibold text-grey-800">No exercises found</h2>
        <p class="text-sm md:text-base text-grey-500">Try adjusting your search or filters</p>
      </div>
    }
    
    </div><!-- Close scrollable content area -->
  </div><!-- Close scroll container -->

  <!-- Fixed Apply Button - only in add/switch mode -->
  @if (showSelectionUI() && selectedExercisesForApply().length > 0) {
    <div class="absolute z-40 rounded-b-[2rem] bottom-0 left-0 right-0 px-4 md:px-8 pb-7 pt-4 md:py-6
    md:bg-white md:border-t md:border-grey-200
    bg-white/60 border-t border-white shadow-lg">
      <div class="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-3 md:gap-4">
        <!-- Selected Exercises Display -->
        <div class="flex-1 flex flex-col gap-2">
          <div class="text-[0.65rem] md:text-xs font-semibold text-grey-600 uppercase">
            {{ selectedExercisesForApply().length }} Selected
          </div>
          <div class="flex items-center gap-1.5 md:gap-2 flex-wrap">
            @for (exercise of selectedExercisesForApply().slice(0, responsiveService.isMobileView() ? 2 : 3); track exercise.id) {
              <div class="flex items-center gap-1.5 md:gap-2 px-2 md:px-3 py-1 md:py-1.5 bg-primary-50 border border-primary-200 rounded-lg text-xs md:text-sm text-grey-900">
                <span class="font-medium text-primary-800 truncate max-w-[120px] md:max-w-[200px]">{{ exercise.name }}</span>
                <button
                  type="button"
                  (click)="onToggleExerciseSelection(exercise)"
                  class="flex items-center justify-center w-4 md:w-5 h-4 md:h-5 rounded-full transition-colors cursor-pointer group">
                  <i class="pi pi-times text-[0.6rem] md:text-xs text-primary-800 group-hover:text-red-600"></i>
                </button>
              </div>
            }
            @if (selectedExercisesForApply().length > (responsiveService.isMobileView() ? 2 : 3)) {
              <div class="flex items-center px-2 md:px-3 py-1 md:py-1.5 bg-gray-100 border border-gray-200 rounded-lg text-xs md:text-sm text-grey-700">
                <span class="font-medium">+{{ selectedExercisesForApply().length - (responsiveService.isMobileView() ? 2 : 3) }} more</span>
              </div>
            }
          </div>
        </div>
        
        <!-- Apply Button -->
        <button
          type="button"
          class="px-4 md:px-6 py-3 md:py-2.5 bg-primary-900
           hover:bg-primary-950 text-white rounded-xl md:rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-base md:text-base"
          (click)="onApplySelection()">
          Apply {{ mode === 'add' ? (selectedExercisesForApply().length > 1 ? 'Exercises' : 'Exercise') : 'Change' }}
        </button>
      </div>
    </div>
  }
</ng-template>

<!-- Exercise View Dialog -->
@if (isViewDialogVisible() && exerciseToView()) {
  <app-client-view-exercise
    [exerciseId]="exerciseToView()!.id"
    [exerciseName]="exerciseToView()!.name"
    [animationPath]="exerciseToView()!.animationPath"
    [level]="exerciseToView()!.level"
    [muscles]="exerciseToView()!.muscles"
    [tags]="[]"
    [category]="exerciseToView()!.category"
    [avgDuration]="exerciseToView()!.avgDuration || 0"
    [availableToVixey]="exerciseToView()!.availableToVixey"
    [showVixeyToggle]="mode === 'browse'"
    [branchId]="selectedBranch()?.id || lockedBranchId"
    [branchName]="selectedBranch()?.name"
    (close)="onCloseViewDialog()"
    (vixeyAvailabilityChanged)="onVixeyAvailabilityChanged()">
  </app-client-view-exercise>
}

<!-- Exercise Filter Dialog -->
@if (isFilterDialogVisible()) {
  <app-exercise-filter-dialog
    [filterConstants]="filterConstants()"
    [currentFilters]="currentFilters()"
    [hideTypeFilter]="hideTypeFilter()"
    (close)="onCloseFilterDialog()"
    (applyFilters)="onApplyFilters($event)">
  </app-exercise-filter-dialog>
}

